import { LegalShell } from "./TermsPage";

export default function PrivacyPage() {
  return (
    <LegalShell title="Privacy Policy" updated="February 2026">
      <section data-testid="privacy-page">
        <h2>1. What we collect</h2>
        <ul>
          <li><strong>Account details</strong> — name, email, password (stored as a secure hash), date of birth and role.</li>
          <li><strong>Profile details you choose to add</strong> — position, team, country, city, region, height, preferred foot, level of play, availability status, bio and photos.</li>
          <li><strong>Content</strong> — posts, match stats, highlight videos, images, comments and messages.</li>
          <li><strong>Fitness data you upload</strong> — optional tracker CSV data (distance, speed, heart rate, etc.).</li>
        </ul>
        <h2>2. How we use it</h2>
        <ul>
          <li>To run the platform: profiles, feeds, search, messaging and notifications.</li>
          <li>To let scouts discover players via filters and saved-search alerts.</li>
          <li>To send transactional emails (alerts, digests, password resets) via our email provider, Resend.</li>
          <li>To keep the platform safe: age gating, youth messaging protections, and reviewing reports.</li>
        </ul>
        <p>We do not sell your personal information.</p>
        <h2>3. Who can see your information</h2>
        <p>
          Your profile (name, position, team, region, stats, availability and public posts) is visible to other EGNCY
          users — that visibility is the point of the platform. Your email, date of birth and password are never shown
          publicly; only your age (in years) is displayed.
        </p>
        <h2>4. Young people</h2>
        <p>
          Player accounts are currently limited to ages <strong>16 and over</strong>. Accounts for 16–17 year olds have
          additional protections: unverified users cannot message them directly and must send a request the player
          approves. We encourage young players to involve a parent or guardian.
        </p>
        <h2>5. Storage and security</h2>
        <p>
          Data is stored on secured cloud infrastructure. Passwords are hashed with bcrypt, sessions use secure
          httpOnly cookies, and media files are stored in access-controlled object storage.
        </p>
        <h2>6. Your rights</h2>
        <p>
          You can edit most profile details at any time, delete your posts, block users, and request a copy or full
          deletion of your data by emailing <strong>admin@egncy.net</strong>. We handle personal information in
          accordance with the Australian Privacy Principles.
        </p>
        <h2>7. Cookies</h2>
        <p>
          We use a session cookie to keep you logged in. No third-party advertising or tracking cookies are used.
        </p>
        <h2>8. Changes</h2>
        <p>
          If this policy changes materially, we'll flag it in-app. Continued use after a change means you accept the
          updated policy.
        </p>
      </section>
    </LegalShell>
  );
}
